
import { computed, defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useId from '@/Hooks/useId'
import { setLocale } from '@vee-validate/i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'Header',
  setup() {
    const ids = useId(['language-select'])
    const { t, locale } = useI18n()
    const localeWatcher = watch(locale, () => {
      setLocale(locale.value)
    })
    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')

    /**
     * 教育向け（KOKO）ビルドかどうか
     */
    const isKokoBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'koko'
    })

    /**
     * MBP向けビルドかどうか
     */
    const isMbpBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'mbp' || enterAccountStore.isMbpOrg
    })

    return {
      ids,
      locale,
      t,
      localeWatcher,
      isKokoBuild,
      isMbpBuild,
    }
  },
})
